"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firebaseSdkConfig = exports.firebaseSdkInit = void 0;
var tslib_1 = require("tslib");
var app_1 = tslib_1.__importDefault(require("firebase/compat/app"));
var _configs = null;
var firebaseSdkInit = function (configs) {
    _configs = configs;
    app_1.default.initializeApp(configs);
};
exports.firebaseSdkInit = firebaseSdkInit;
var firebaseSdkConfig = function () {
    return _configs;
};
exports.firebaseSdkConfig = firebaseSdkConfig;
